module.exports = __webpack_public_path__ + "img/facebook-dark.799f2510.svg";